import { defineMessages } from 'react-intl'

export default defineMessages({
  RedirectedTo: {
    id: 'components.PaymentMethods.App.RedirectedTo',
    defaultMessage: 'You are going to be redirected to',
    description: '请修改',
  },
  ScanandPayWith: {
    id: 'components.PaymentMethods.App.ScanandPayWith',
    defaultMessage: 'Scan the QR code with Aani',
    description: '请修改',
  },
  Processing: {
    id: 'components.PaymentMethods.App.Processing',
    defaultMessage: 'Processing...',
    description: '请修改',
  },
  TryAgain: {
    id: 'components.PaymentMethods.AaniPay.TryAgain',
    defaultMessage: 'Try Again',
    description: '请修改',
  },
  CashierPage:{
    id: 'components.PaymentMethods.CashierPage',
    defaultMessage:' cashier page',
    description:'请修改'
  },
  Next: {
    id: 'components.PaymentMethods.App.Next',
    defaultMessage:'Next',
    description:'请修改'
  },
  HighlightAaniPayName:{
    id: 'components.PaymentMethods.HighlightAaniPayName',
    defaultMessage:'AaniPay',
    description:'请修改'
  },
  ProcessingDescription:{
    id: 'components.PaymentMethods.ProcessingDescription',
    defaultMessage:'Please continue to your transaction on',
    description:'请修改'
  },
  GeneratingQRCode:{
    id: 'components.PaymentMethods.AaniPay.GeneratingQRCode',
    defaultMessage:'Generating QR Code..',
    description:'Loading state text'
  },
  Pay: {
    id: 'components.PaymentMethods.AddNewCard.Pay',
    defaultMessage: 'Pay',
    description: '请修改',
  },
  validRule: {
    id: 'utils.validateRules.validRule',
    defaultMessage: 'Invalid Mobile number',
    description: '校验规则: 格式校验',
  },
})
